export default __webpack_public_path__ + "static/media/StallReport.a179a826.png";